import { useGetETFChartData } from '#/api/generated/etf/etf';

import { normalizeProductTypeChartData } from './normalize';
import { ProductTypeChartSection } from './ProductTypeChartSection';
import type { ChartTimeframeId } from './types';

interface ETFChartSectionProps {
  symbol: string;
  initialTimeframe?: ChartTimeframeId;
  previousClose?: number | null;
}

export function ETFChartSection({
  symbol,
  initialTimeframe = '5Y',
  previousClose,
}: ETFChartSectionProps) {
  return (
    <ProductTypeChartSection
      symbol={symbol}
      initialTimeframe={initialTimeframe}
      useChartQuery={useGetETFChartData}
      normalizeChartData={normalizeProductTypeChartData}
      previousClose={previousClose}
    />
  );
}
